<form #validateForm="ngForm" class="app-form" novalidate *ngIf="showForm">
    <vue-panel [title]="'title.EnterVueID' | translate | async">
        <p>{{ 'message.EnterVueIDText' | translate | async }}</p>
        {{ 'message.ClickSkipIfEitherApplies' | translate | async }}
        <ul>
            <li>{{ 'message.YouDoNotKnowYourVueId' | translate | async }}</li>
            <li>{{ 'message.YouDoNotHaveAVueIdYetBecauseYouAreNew' | translate | async }}</li>
        </ul>
        <vue-control-group
                [control]="vueID"
                [formError]="formError"
                [label]="'label.VueId' | translate | async">
            <div class="input-group-append">
                <input  name="vueID"
                        id="vueID"
                        class="form-control"
                        [(ngModel)]="vueId"
                        #vueID="ngModel"
                        [vueMinInteger]="1"
                        [vueMaxInteger]="2147483647"
                        (ngModelChange)="onVueIdChange()"
                        autocomplete="off"
                        required
                        vueInteger/>
                <button class="btn btn-default btn-xs validate-btn validate-btn-space" type="button" (click)="validateVueId()">
                    {{ 'label.Validate' | translate | async }}
                </button>
            </div>
        </vue-control-group>

        <div *ngIf="vueIdValidated">
            <fa-icon class="fa fa-fw validation-success"
                     icon="check">
            </fa-icon>
            <span class="validation-success">{{ 'label.ValidVueId' | translate | async }}</span>
            <br><br>
        </div>
        <a class="validation-info-text" href="/WebHelp/Connect/Enter_Your_VUE_ID.htm" target="_blank">{{ 'label.VueIdHelpLink' | translate | async }}</a>
        <br><br>

        <vue-form-buttons
                i18nBundle="Connect"
                [primaryLabelKey]="vueIdValidated ? 'button.Submit': ''"
                (primaryButtonClicked)="submit()"
                (secondaryButtonClicked)="next()"
                secondaryLabelKey="button.Skip">
        </vue-form-buttons>
    </vue-panel>

</form>
